module.exports = __webpack_public_path__ + "media/images/homepage/noise-13bca7a1bc1a1873475026cc76254828.svg";